
const frequencyEls = document.querySelectorAll(".page-pricelist [name=frequency]");
const frequencyMobileCheckEl = document.querySelector(".page-pricelist #year-month-checkbox");
const showMoreEls = document.querySelectorAll(".price-variant__show-more");
const singlePaymentEls = document.querySelectorAll(".page-pricelist [data-single-payment]");
const saleEls = document.querySelectorAll(".page-pricelist [data-sale]");
const switchMobileLabelEls = document.querySelectorAll(".page-pricelist .period-switcher__switch-wrap-mobile .switch-mobile-label");

function toggleText(el) {
	const originalText = el.innerText;
	const closeText = el.dataset.text;

	if (el.innerText === originalText) {
		el.innerText = closeText;
	} else {
		el.innerText = originalText;
	}
}

function togglePrices() {
	singlePaymentEls.forEach(el => {
		el.classList.toggle("hidden-price");
	});

    saleEls.forEach(el => {
        el.classList.toggle("display-none");
    })
}

showMoreEls.forEach(el => {
	const originalText = el.innerText;
	const closeText = el.dataset.text;

	if (el.classList.contains("collapse--active")) {
		toggleText(el);
	}

	el.addEventListener("click", function() {
		if (this.innerText === originalText) {
			this.innerText = closeText;
		} else {
			this.innerText = originalText;
		}
	});
});

frequencyEls.forEach(el => {
	let frequency = this.value;

	el.addEventListener("change", function(e) {
		togglePrices();
	})
});

if (frequencyMobileCheckEl) {
	frequencyMobileCheckEl.addEventListener("click", function() {
		const disabledClass = "switch-mobile-label--disabled";
		const radioYearEl = document.querySelector("[data-label=radio-year]");
		radioYearEl.classList.toggle(disabledClass);

		const radioMonthEl = document.querySelector("[data-label=radio-month]");
		radioMonthEl.classList.toggle(disabledClass);

		togglePrices();
	});
}

switchMobileLabelEls.forEach(el => {
	el.addEventListener("click", () => {
		frequencyMobileCheckEl.click();
	});
})

